import { createSelector } from 'reselect';
import config             from '../config';


const selectAuthModuleState = (state) => state.get(config.statePath);

/**
 * Selector for JWT in state
 *
 * @param {object} state
 *
 * @return {?Map}
 *
 * @todo TESTS: Add all
 */
const selectJwt = createSelector(
  selectAuthModuleState,
  (moduleState) => moduleState.get('jwt'),
);


export { selectJwt };


// WEBPACK FOOTER //
// ./src/modules/auth/selectors/authSelectors.js